import { Adresse } from "./adresse";

export class CoproprieteDestinataire {

    cop_id: string = null;
    cop_adr_id: string;
    cop_adr_secondaire_id: string;
    cop_nom: string;
    cop_nom_secondaire: string;
    cop_code: string;
    cop_description: string;
    cop_email: string;
    cop_code_ics: string;
    cop_code_numero_entreprise: string;
    cop_guid: string;
    
    adresse: Adresse;
    adresse_secondaire: Adresse;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.cop_id                     = data['cop_id'] ? data['cop_id'] : null;
        this.cop_adr_id                 = data['cop_adr_id'] ? data['cop_adr_id'] : null;
        this.cop_adr_secondaire_id      = data['cop_adr_secondaire_id'] ? data['cop_adr_secondaire_id'] : null;
        this.cop_nom                    = data['cop_nom'] ? data['cop_nom'] : null;
        this.cop_nom_secondaire         = data['cop_nom_secondaire'] ? data['cop_nom_secondaire'] : null;
        this.cop_code                   = data['cop_code'] ? data['cop_code'] : null;
        this.cop_description            = data['cop_description'] ? data['cop_description'] : null;
        this.cop_email                  = data['cop_email'] ? data['cop_email'] : null;
        this.cop_code_ics               = data['cop_code_ics'] ? data['cop_code_ics'] : null;
        this.cop_code_numero_entreprise = data['cop_code_numero_entreprise'] ? data['cop_code_numero_entreprise'] : null;
        this.cop_guid                   = data['cop_guid'] ? data['cop_guid'] : null;
        
        this.adresse                    = data['adresse'] ? new Adresse(data['adresse']) : new Adresse();
        this.adresse_secondaire         = data['adresse'] ? new Adresse(data['adresse']) : new Adresse();
    }


}
